<div
  *ngIf="notification.show"
  aria-live="polite"
  aria-atomic="true"
  id="polite-alert"
>
  <div
    class="alert bounce"
    [ngClass]="
      notification.style === 'success'
        ? 'custom-success'
        : notification.style === 'danger'
        ? 'custom-danger'
        : 'custom-info'
    "
    role="alert"
  >
    <div class="d-flex flex-row">
      <img
        class="mr-4 d-none d-md-inline"
        src="/assets/icons/alert-tick.svg"
        alt=""
      />
      <p class="content mb-0 primary-font-normal">
        {{ notification.content }}
      </p>
    </div>
    <img (click)="dismiss()" src="/assets/icons/cancel.svg" alt="close" />
  </div>
</div>
